import get from 'lodash/get';
import { css_beautify } from 'js-beautify';
import stringify from 'json-stable-stringify';

function isSelector(key) {
  key = key.trim();
  if (key.startsWith('#')) return true;
  if (key.startsWith('.')) return true;
  if (key.startsWith('&')) return true;
  if (key.startsWith(':')) return true;
  return false
}

function cleanKey(key) {
  key = key.replace(" &", "");
  key = key.trim();
  return key
}

function flatten(object) {
  let output = {};

  function step(node, parentKey="") {
    Object.keys(node).forEach(function(key) {
      const value = node[key];
      const attributes = {};
      const children = {};

      const type = Object.prototype.toString.call(value);
      const isObject = (
        type === '[object Object]' ||
        type === '[object Array]'
      );

      if (isObject) {
        Object.keys(value).forEach(function(rowKey) {
          const rowValue = value[rowKey];
          if (!isSelector(rowKey)) {
            attributes[rowKey] = rowValue;
          }

          if (isSelector(rowKey)) {
            let stepKey = `${key} ${rowKey}`;
            if (parentKey) stepKey = `${parentKey} ${key} ${rowKey}`;
            step(rowValue, stepKey);
          }
        })
      }

      if (!isObject) {
        attributes[key] = value;
      }

      let outputKey = parentKey;
      if (isObject) outputKey = `${parentKey} ${key}`;
      outputKey = cleanKey(outputKey);
      output[outputKey] = attributes;
    })
  }

  step(object);
  return output;
}

function removeEmptyCssAttribute(obj) {
  Object.keys(obj).forEach(k =>
    (obj[k] && typeof obj[k] === 'object') && removeEmptyCssAttribute(obj[k]) ||
    (obj[k] === "" || obj[k] === null) && delete obj[k]
  );
  return obj;
};

export function jsonToScss(object, config={}) {
  let ordered = get(config, 'ordered', true);
  let removeEmpty = get(config, 'removeEmpty', true);

  if (removeEmpty) {
    object = removeEmptyCssAttribute(object);
  }

  let text = '';
  if (ordered) {
    text = stringify(object, {space: 2});
  } else {
    text = JSON.stringify(object, null, 2);
  }

  let pattern = /({)([\s\S]*)(})/gm;
  text = text.replace(pattern, '$2');

  pattern = /("[^"]*":[ "]"[^"]*")([,]*)/gm;
  text = text.replace(pattern, '$1;');

  pattern = /(}),/gm;
  text = text.replace(pattern, '$1');

  pattern = /(:)([ ]*{)/gm;
  text = text.replace(pattern, '$2');

  pattern = /"([^"]*)":[ "]"([^"]*)"/gm;
  text = text.replace(pattern, '$1: $2');

  pattern = /"([^"]*)"[ ]*{/gm;
  text = text.replace(pattern, '$1 {');
  text = text.trim();
  return text;
}

export function jsonToCss(object) {
  object = removeEmptyCssAttribute(object);
  let flattenedObject = flatten(object);
  return jsonToScss(flattenedObject);
}
